import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Quote } from '@zero/shared/util-models';
import { Crypto } from '../entities/crypto.model';
import { ETPListItem } from '../entities/etp.model';

export const cryptoActions = createActionGroup({
  source: 'crypto',
  events: {
    loadCryptos: emptyProps(),
    subscribeToCryptoQuotes: emptyProps(),
    unsubscribeFromCryptoQuotes: emptyProps(),
    updateCryptoQuotes: props<{ quotes: Record<string, Quote>; historicQuotes: Record<string, Quote> }>(),
    updateCryptos: props<{ cryptos: Crypto[] }>(),
    loadETPs: emptyProps(),
    subscribeToETPQuotes: emptyProps(),
    unsubscribeFromETPQuotes: emptyProps(),
    updateETPQuotes: props<{ quotes: Record<string, Quote>; historicQuotes: Record<string, Quote> }>(),
    updateETPs: props<{ etps: ETPListItem[] }>(),
  },
});

export const cryptoApiActions = createActionGroup({
  source: 'crypto api',
  events: {
    loadCryptosFromApi: emptyProps(),
    loadCryptosSuccess: props<{ cryptos: Crypto[] }>(),
    loadCryptosFailure: props<{ error: HttpErrorResponse }>(),
    loadETPsFromApi: emptyProps(),
    loadETPsSuccess: props<{ etps: ETPListItem[] }>(),
    loadETPsFailure: emptyProps(),
  },
});

export const cryptoActionIgnoreList = [
  cryptoActions.updateCryptoQuotes.type,
  cryptoActions.updateCryptos.type,
  cryptoActions.updateETPQuotes.type,
  cryptoActions.updateETPs.type,
];
